import { render, staticRenderFns } from "./AppRefCard.vue?vue&type=template&id=55d4ed22&"
import script from "./AppRefCard.vue?vue&type=script&lang=js&"
export * from "./AppRefCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports